import { AsphaltLotId } from '../filenameTemplateItems/instances/asphalt'
import { ConcreteTestSetId } from '../filenameTemplateItems/instances/concrete'
import {
  DailyControlPointId,
  DailyInspectionId,
  DailyPunchListId,
} from '../filenameTemplateItems/instances/dailyInspection'
import { DensityLotId } from '../filenameTemplateItems/instances/density'
import {
  asphalts,
  concretes,
  controlPoints,
  densities,
  inspections,
  projects,
  punchLists,
  workTypes,
} from '../filenameTemplateItems/instances/groups'
import { PhotoExportClassTypeItem } from './PhotoExportClassTypeItem'

export const AsphaltLot = new PhotoExportClassTypeItem({
  id: '647d47f9-bb57-4268-8e75-fbdeeb314581',
  classType: 'AsphaltLot',
  classTypeName: 'Asphalt Lot',
  compatibleTemplateItems: [...projects, ...asphalts],
  identifier: AsphaltLotId,
})

export const ConcreteTestSet = new PhotoExportClassTypeItem({
  id: '4bce71aa-8448-4635-8a06-5c9e71766cda',
  classType: 'ConcreteTestSet',
  classTypeName: 'Concrete Test Set',
  compatibleTemplateItems: [...projects, ...concretes, ConcreteTestSetId],
  identifier: ConcreteTestSetId,
})

export const ControlPoint = new PhotoExportClassTypeItem({
  id: 'c74f58f7-d347-4b7b-8b47-1d64cbc46df1',
  classType: 'DailyInspectionControlPoint',
  classTypeName: 'Control Point',
  compatibleTemplateItems: [...projects, ...workTypes, ...controlPoints],
  identifier: DailyControlPointId,
})

export const Inspection = new PhotoExportClassTypeItem({
  id: '83bb008b-5249-4b28-9399-0e7ff7b3a405',
  classType: 'DailyInspectionInspection',
  classTypeName: 'Inspection',
  compatibleTemplateItems: [...projects, ...workTypes, ...inspections],
  identifier: DailyInspectionId,
})

export const PunchList = new PhotoExportClassTypeItem({
  id: 'f4db0ce2-9ad3-4926-8014-4e59110c002e',
  classType: 'DailyInspectionPunchList',
  classTypeName: 'Punch List',
  compatibleTemplateItems: [...projects, ...workTypes, ...punchLists],
  identifier: DailyPunchListId,
})

export const DensityLot = new PhotoExportClassTypeItem({
  id: 'aaa44a4f-9b7f-4193-a8ae-7cf6f9caf2f0',
  classType: 'Lot',
  classTypeName: 'Density Lot',
  compatibleTemplateItems: [...projects, ...densities],
  identifier: DensityLotId,
})
